import {createSlice} from "@reduxjs/toolkit";
import {getIncomeStatementBookings, getIncomeSummary} from "@/store/income-statement/action";

const initialState = {
  state: {
    summary: null,
    bookings: [],
    bookingsPaging: null
  },
  loading: true,
  error: ''
} as BaseState<IncomeStatementState>

const slice = createSlice({
  name: 'incomeStatement',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // income summary
    builder.addCase(getIncomeSummary.pending, (state) => ({
      ...state,
      loading: true
    }))
    builder.addCase(getIncomeSummary.fulfilled, (state, action) => ({
      state: {
        ...state.state,
        summary: action.payload
      },
      loading: false,
      error: null
    }))
    builder.addCase(getIncomeSummary.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get coupons, please try again'
    }))
  
    // income statement bookings
    builder.addCase(getIncomeStatementBookings.pending, (state) => ({
      ...state,
      loading: true
    }))
    builder.addCase(getIncomeStatementBookings.fulfilled, (state, action) => ({
      state: {
        ...state.state,
        bookings: action.payload.items,
        bookingsPaging: action.payload.paging
      },
      loading: false,
      error: null
    }))
    builder.addCase(getIncomeStatementBookings.rejected, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to get income statement bookings, please try again'
    }))
  }
})

export default slice
